import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Chart as ChartJS, registerables } from "chart.js";
import farmService from "../../services/farm-service";
import lotService from "../../services/lot-service";
import dashboardService from "../../services/dashboard-service";
import sectionService from "../../services/section-service";
import { registerLocale } from "react-datepicker";
import { es } from "date-fns/locale/es";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Divider, Spin } from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";
import BarchartDay from "../DashBoard/BarchartDay";
import moment from "moment/moment";
import 'moment/locale/es';
import config from "../../config/config";
import Select from "react-select";
import MultiLineCycles from "../DashBoard/MultiLineCycles";



// Registrar componentes para Chart.js
ChartJS.register(...registerables);

const DashboardFirstApplicationsYear = () => {


  const currentYear = new Date().getFullYear()
  const startYear = 2023;
  const [year1, setYear1] = useState(currentYear);
  const [year2, setYear2] = useState(currentYear);
  const [title, setTitle] = useState("Comparativo anual");

  const chartOneRef = useRef(null);
  const [showLineValues, setShowLineValues] = useState(true)
  const [expandChats, setExpandCharts] = useState(false)

  ///Aplicaciones por dia
  const [lotId, setLotId] = useState("0");
  const [farmId, setFarmId] = useState("0");


  ////CONSTANTES DE COORRELACION////////////////////////

  /*registerLocale("es", es);
  const start_date = moment().add(-config.DAYS_LESS, 'd').startOf("day").toDate();
  const end_date = moment().endOf("day").toDate();*/


  registerLocale("es", es);
  const start_date = moment().subtract(1, 'month').startOf('month').toDate();
  const end_date = moment().subtract(1, 'month').endOf('month').toDate();




  const [dataCycles, setDataCycles] = useState([])
  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date);

  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);
  const [listSection, setListSection] = useState(escoja);
  const [sectionId, setSectionId] = useState("0");


  const [type, setType] = useState("$totalFirst");
  const [labelTypeSelected, setLabelTypeSelected] = useState("Primera");
  const [labelType, setLabelType] = useState("Primera");
  const listType = [
    { _id: "$totalFirst", name: "Aplicaciones de primera", label: "Aplicaciones de primera" },
    { _id: "$totalSecond", name: "Aplicaciones de segunda", label: "Aplicaciones de segunda" },
    { _id: "$totalThird", name: "Aplicaciones de tercera", label: "Aplicaciones de tercera" },
    { _id: "$total", name: "Total de aplicaciones", label: "Total de aplicaciones" }
  ]


  const listYears = [];
  for (let year = startYear; year <= currentYear; year++) {
    listYears.push({
      id: year.toString(),
      name: year.toString()
    });
  }

  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  const [options, setOptions] = useState([])
  const [selectedLotes, setSelectedLotes] = useState([]);
  const handleSelectChange = (selectedOptions) => {
    setSelectedLotes(selectedOptions || []);
  };

  // Estilos personalizados  
  const customStyles = {
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#CBEDFE",
      fontFamily: "inherit",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
    menu: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
  };
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////


  const formatDate = (dateString) => {
    return moment(dateString).locale('es').format('DD MMM');
  };

  const formatMonth = (yearMonth) => {
    const [year, month] = yearMonth.split("-").map(Number);
    const date = new Date(year, month - 1);
    return new Intl.DateTimeFormat("es-ES", { month: "short", year: "numeric" }).format(date);
  };

  const formatMonthYearIntl = (yearMonth) => {
    const [year, month] = yearMonth.split("-").map(Number);
    const date = new Date(year, month - 1);
    return new Intl.DateTimeFormat("es-ES", { month: "short", year: "numeric" }).format(date);
  };

  const changeStateShowValues = (e) => {
    setShowLineValues(!e.target.checked)
  }

  const changeExpand = (e) => {
    setExpandCharts(e.target.checked)
  }

  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
      //setValue("farm",0)
    }
  };

  const getListSection = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setFarmId(code);
    if (code == "0") {
      setListSection(escoja);
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
    }
  };

  const getLisLots = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setSectionId(code);
    if (code == "0") {
      setListLots(escoja);
      return;
    }
    let listado = await lotService.getListBySection(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
      const newOptions = sortedItems.map((lote) => ({
        value: lote._id,
        label: lote.name,
      }));
      setOptions(newOptions)
    }
  };






  /// APLICACIONES POR  MES
  const firstApplicationMonth = async () => {


    let year1 = getValues("year1")
    let year2 = getValues("year2")

    setTitle(`Comparativo ${year1} vs ${year2}`)
    const params = { year1, year2, farmId, lotId, sectionId, lots: selectedLotes, type };
    const result = await dashboardService.firstApplicationYear(params);
    if (result.length == 0) {
      //toast.info("No hay datos para mostrar", { autoClose: 1500 })
    }
    setDataCycles(result)
  };







  const loadDashBoard = () => {
    firstApplicationMonth()
    setLabelType(labelTypeSelected)
  };

  useEffect(() => {
    getLisFarm();
    //loadDashBoard()
  }, []);

  const {
    control,
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      year1: currentYear,
      year2: currentYear
    }
  });


  const cardStyle = {
    padding: "20px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    borderRadius: "10px",
    backgroundColor: "#fff",
  };

  const saveAsImage = (chartRef, title) => {
    if (chartRef.current) {
      const echartsInstance = chartRef.current.getEchartsInstance();
      const imgData = echartsInstance.getDataURL({
        type: "jpeg", // Formato de la imagen ('png', 'jpeg')
        pixelRatio: 2, // Relación de píxeles (mayor = imagen de mayor calidad)
        backgroundColor: "#fff", // Fondo de la imagen
      });

      // Crear un enlace para descargar la imagen
      const link = document.createElement("a");
      link.href = imgData;
      link.download = title; // Nombre del archivo
      link.click();
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Comparativo anual</Divider>
      </div>
      <div className="row">
        <div className="col-12">
          <form className="form-react"
            defaultValue={{ year1: 2026 }}
          >
            <div className="row mb-3">


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Finca</label>
                <select
                  className="form-control text-secondary"
                  {...register("farm")}
                  onChange={(e) => getListSection(e)}
                >
                  {listFarms.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Sección</label>
                <select
                  className="form-control text-secondary"
                  {...register("section")}
                  onChange={(e) => getLisLots(e)}
                >
                  {listSection.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>



              <div className="col-6 col-sm-2 ">
                <label>Año A</label>
                <select className="form-control" {...register("year1")}>
                  {listYears.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className="col-6 col-sm-2 ">
                <label>Año B</label>
                <select className="form-control" {...register("year2")}>
                  {listYears.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>



              <div className="col-6 col-sm-2 d-none">
                <label className="text-secondary fw-bold">Desde</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control text-secondary"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </div>

              <div className="col-6 col-sm-2 d-none">
                <label className="text-secondary fw-bold">Hasta</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control 
                text-secondary"
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                />
              </div>

              <div className="col-12 col-sm-2">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <button
                  className="btn btn-primary w-100"
                  type="button"
                  onClick={() => loadDashBoard()}
                >
                  <i className="bi bi-search fa-lg m-2" /> Cargar gráficos
                </button>
              </div>


              <div className="col-12 col-sm-6">
                <label className="text-secondary fw-bold">Lotes</label>
                <Select
                  isMulti
                  options={options}
                  value={selectedLotes}
                  styles={customStyles}
                  onChange={handleSelectChange}
                  placeholder="Selecciona lotes..."
                />
              </div>

              <div className=" col-4">
                <label className="text-secondary fw-bold">Tipo</label>
                <select
                  className="form-control text-secondary"
                  {...register("type")}
                  onChange={(e) => {
                    const value = e.target.value
                    console.log(e)
                    setType(value)
                    const selected = listType.find(a => a._id == value)
                    setLabelTypeSelected(selected.label)
                  }}
                >
                  {listType.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


            </div>



          </form>
        </div>





        <div className={expandChats ? "col-12 mt-2" : "col-12 col-sm-12 mt-2"}>
          <div style={cardStyle}>
            <MultiLineCycles
              chartRef={chartOneRef}
              title={title}
              nameLine="Hectáreas"
              nameBar="Aplicaciones"
              subTitle=""
              showSerieValue={showLineValues}
              decimals={0}
              labelY="Inflorescencias"
              data={dataCycles}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartOneRef, "ciclos-polinizacion.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default DashboardFirstApplicationsYear;
